<template>
  <v-container>
    <!--app-view-toolbar-->
    <app-view-toolbar :title="headline" :showBackButton="true" :isEdit="false"></app-view-toolbar>
    <template v-if="viewDataIsLoaded">
      <div class="text-h5 mb-4">{{ viewData.name }}</div>
      <v-row
        v-if="viewData.signingStatus == 'assignedToDriver'"
      >
        <!--assignment has been assigned to driver-->
        <v-col>
          <v-card
            class="mx-auto"
            color="accent"
            dark="dark"
          >
            <div class="pa-4">
              <div class="text-body">
                Chauffören tilldelades jobbet <span class="font-weight-bold">{{ viewData.signingData.assignmentName }}</span>  {{ viewData.signingData.driverAssignedDate }}
              </div>
              <div v-if="!isMobile" class="text-body mt-2">
                Du når chauffören på: {{ viewData.contactData.phone }}
              </div>
              <div>
                <v-btn
                  class="mt-2 mr-2"
                  :href="'mailto:' + viewData.contactData.email"
                  target="_blank"
                >
                  <v-icon left>mdi-email-outline</v-icon>
                  Maila
                </v-btn>
                <v-btn
                  class="mt-2 mr-2"
                  v-if="isMobile"
                  :href="'tel:' + viewData.contactData.phone"
                >
                  <v-icon left>mdi-phone</v-icon>
                  Ring
                </v-btn>
                <v-btn
                  class="mt-2"
                  @click="openAgreement(viewData.agreementFileData.url)"
                >
                  <v-icon left>mdi-glasses</v-icon>
                  Avtal
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!--
      <template v-if="viewData.profileData.signingContactData_ar">
        <app-data-card title="Kontaktinfo" color="grey lighten-3" :dark="false" :data_ar="viewData.profileData.signingContactData_ar" class="mb-6" mode="view"></app-data-card>
      </template>
      -->
      <!--driver data-card-->
      <app-data-card title="Allmän info" color="grey lighten-3" :dark="false" :data_ar="viewData.profileData.driverData_ar" class="mb-6" mode="view"></app-data-card>
      <!--driver qualification display-->
      <app-driver-qualification-display :qualificationAreaData_ar="viewData.qualificationAreaData_ar"></app-driver-qualification-display>
      <template v-if="viewData.signingStatus == 'driverHasSignedAndIsAssignable'">
        <!--driver has signed and is assignable - show sign stuff-->
        <div class="text-h6 mt-6">Acceptera chaufför</div>
        <v-row>
          <v-col>
            <div class="text-body pb-2">
              Acceptera chauffören <span class="font-weight-bold">{{ viewData.name }}</span> för jobbet <span class="font-weight-bold">{{ viewData.signingData.assignmentName }}</span>
            </div>
            <v-btn
              class="my-2"
              color="secondary"
              @click="openAgreement(viewData.signingData.agreementUrl)"
            >
              Öppna avtalsförslag
            </v-btn>
            <v-form ref="formSignAgreement" class="pb-4">
              <v-checkbox
                v-model="acceptTerms"
                :rules="[formRules.checked(acceptTerms, 'Du måste godkänna villkoren')]"
                label="Jag godkänner villkoren i avtalsförslaget"
              ></v-checkbox>
            </v-form>
            <v-btn
              color="accent"
              @click="acceptDriver()"
              large
            >
              Acceptera chauffören
            </v-btn>
          </v-col>
        </v-row>
        <!--bank-id-->
        <app-bank-id
          headline="Signera med BankID"
          mode="sign"
          :message="viewData.bankIdData.message"
          :dialog="showBankIdDialog"
          @close="showBankIdDialog = false"
          @complete="onBankIdComplete"
          :returnUrl="bankIdReturnUrl"
          :bankIdData="viewData.bankIdData"
        ></app-bank-id>
      </template>
    </template>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>

<script>
import axios from 'axios'
import SnackBar from '../components/SnackBar'
import ViewToolbar from '../components/ViewToolbar'
import DataCard from '../components/DataCard'
import DriverQualificationDisplay from '../components/DriverQualificationDisplay'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { s3Mixin } from '../mixins/s3'
import { googleMapMixin } from '../mixins/googleMap'
import { snackBarBus } from '../main'
import { mapGetters } from 'vuex'

export default {
  name: 'Assignment',
  components: {
    'app-bank-id': () => import('../components/BankId'),//lazy load BankID
    'app-snack-bar': SnackBar,
    'app-data-card': DataCard,
    'app-driver-qualification-display': DriverQualificationDisplay,
    'app-view-toolbar': ViewToolbar
  },
  mixins: [generalMixin, urlMixin, googleMapMixin, s3Mixin],
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      viewData: {},
      headline: 'Chaufför',
      acceptTerms: false,
      viewDataIsLoaded: false,
      bankIdReturnUrl: '',
      showBankIdDialog: false,
      bankIdToken: null,
      asgUuid: null,
      isViewingByAssignment: false
    }
  },
  computed: {
    ...mapGetters(['access_token', 'loggedInData']),
    isCompany() {
      return this.loggedInData.agentData.type == 'company'
    },
  },
  watch: {
    viewDataIsLoaded(value) {
      if (value) {
        //set headline
      }
    }
  },
  methods: {
    openAgreement(url) {
      let cachelessUrl = this.url_composeCachelessUrl(url)
//      console.log(cachelessUrl)
      window.open(cachelessUrl)
    },
    acceptDriver() {
      const formIsValid = this.$refs.formSignAgreement.validate()
      if (formIsValid) {
        this.showBankIdDialog = true
      }
    },
    onBankIdComplete() {
//      console.log("Assignment - onBankIdComplete", token)
      this.showBankIdDialog = false
      //go to company dashboard with assigned tab active, like this
      this.$router.replace({ name: 'company-dashboard', hash: '#assigned' })
    }
  },
  created() {
    if (this.$route.query.asgUuid) {
      //viewing a (signed) driver from an assignemnt
      this.asgUuid = this.$route.query.asgUuid
      this.isViewingByAssignment = true
    }
    //get view data
    let config = {
      headers: {
        'Authorization': this.access_token
      }
    }
    //post data to API
    let postData = {
      //post agentData in order to return specific data depending on "who's watching"
      agentData: this.loggedInData.agentData
    }
    if (this.asgUuid) {
      //also post asgUuid in order to get signed status for driver towards specific assignemnt
      postData.asgUuid = this.asgUuid

    }
    let url = this.url_composeApiUrl('/driver/' + this.uuid)
//    console.log("post url", url)
//    console.log("postData", postData)
    axios.post(url, postData, config)
      .then(response => {
//        console.log('get response', response)
        if (response.data.success) {
          //success
          this.viewData = response.data.returnData.viewData
          this.viewDataIsLoaded = true
        } else if (this.onNonSuccessApiCall(response.data.returnData)) {
          snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
        }
      })
      .catch(error => {
        snackBarBus.$emit('message', error.toString())
      })
  }
}
</script>

<style>

</style>